import { StyleSheet } from "react-native";

export default StyleSheet.create({
  SortButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});
